import React, { useEffect, useState } from 'react'
import Layout from '../../../layout'
import HeaderHome from './components/HeaderHome'
// import Service from './components/Service';
// import Car from './components/Car';
// import Car from './components/newCars';
import { makeStyles } from "@material-ui/core";
import Customers from "./components/Customers";
import TextWithImg from "./../../common/TextWithImg";
import Stockpeople from './components/stockpeople';
import TypeBrokerServices from './components/typeBrokerServices';
import DescBroker from './components/descBroker';
import Online from './components/online';
import News from './components/news_new';
import Register from './components/register';
import Supporttext from './components/Supporttext';

// import CardModal from './components/cardModal';
// import DescriptionPishro from './components/descriptionPishro';
// import ServiceTwo from './components/ServiceTwo';
import CardService from './components/cardService';

const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        minHeight: 1300
    },
    background: {
        width: "100%",
        height: 1300,
        background: "url('/assets/images/background-home.svg') center center",
        position: "absolute",
        filter: "grayscale(100%)",
        top: 220,
        zIndex: -1,
        [theme.breakpoints.down("sm")]: {
            top: 670
        }
    },
    wrapper: {
        // position: 'absolute',
        position: 'relative',
        width: '100%',
        height:'auto',
        top: 0,
    },

}))


export default function Home() {
    
    const classes = useStyles()
    
    
  useEffect(() => {
      document.title = `وب سایت کارگزاری پویان`;
  }, []); 


    {/* <div className={classes.background}></div> */}
    {/* <Stockpeople /> */}
    return (
        <Layout home>
            <div className={classes['wrapper']}>
                <HeaderHome home />
            </div>
            <div className={classes.root} >
                <div className={classes.content}>
                    <CardService />
                    <TypeBrokerServices />
                    <DescBroker />
                    <Online />
                    <News />
                    <Register />
                    <div style={{ margin: "20px 0px 90px 0px" }}>
                        <Customers />
                    </div>
                    <Supporttext />
                </div>
            </div>
        </Layout >
    )
}
